import axios, {AxiosResponse} from 'axios'

import {PlanFeatures, PlanFeaturesQueryResponse} from './_models'
import {getToken} from '../../../../auth'

//BASE_URL LINK
const API_URL = process.env.REACT_APP_API_URLS
console.log("API_URL",API_URL);

//ROLE API URL
const CREATE_PLANFEATURES_URL = `${API_URL}/planfeatures/add`
const GET_PLANFEATURES_URL = `${API_URL}/planfeatures/query`
const VIEW_PLANFEATURES_URL = `${API_URL}/planfeatures/view`
const UPDATE_PLANFEATURES_URL = `${API_URL}/planfeatures/update`
const DELETE_PLANFEATURES_URL = `${API_URL}/planfeatures/delete`
const DUPLICATE_PLANFEATURES_URL = `${API_URL}/planfeatures/find-duplicate`


//AuthVerify
var AuthVerify = getToken.call(this)

//Color LIST
const getPlanFeatures = (query: string): Promise<PlanFeaturesQueryResponse> => {
  return axios
    .get(`${GET_PLANFEATURES_URL}/?${query}`, AuthVerify)
    .then((response: AxiosResponse<PlanFeaturesQueryResponse>) => {
      console.log('get-Plannnnn==>', response.data)
      return response.data
    })
}

//PlanFeatures ADD
const createPlanFeatures = (data: any): Promise<PlanFeatures | undefined> => {
  return axios
    .post(CREATE_PLANFEATURES_URL, data, getToken())
    .then((response: any) => response.data)
}

//PlanFeatures VEIW
const viewPlanFeatures = (id: any) => {
  return axios.get(`${VIEW_PLANFEATURES_URL}/${id}`, getToken()).then((response) => {
    console.log('view-PlanFeatures', response.data)
    return response.data
  })
}

//PlanFeatures UPDATE
const updatePlanFeatures = (data: any, id: any) => {
  console.log('reqData=update-PlanFeatures idddd', id)
  console.log('reqData=update-PlanFeatures', data)
  return axios.put(`${UPDATE_PLANFEATURES_URL}/${id}`, data, getToken()).then((response) => {
    console.log('updatemp-Plan', response.data)
    return response.data
  })
}

//PlanFeatures DELETE
const deletePlanFeaturesById = (id: any) => {
  return axios.put(`${DELETE_PLANFEATURES_URL}/${id}`, AuthVerify).then((response) => {
    return response.data
  })
}

// const checkDuplicatePlanFeatures = (name: any) => {
//   return axios
//     .post(`${DUPLICATE_PLANFEATURES_URL}`, { name }, getToken())
//     .then((response) => {
//       return response.data;
//     });
// };

const checkDuplicatePlanFeatures = (name: any) => {
  return axios
    .post(`${DUPLICATE_PLANFEATURES_URL}`, { name }, getToken())
    .then((response) => {
      return response.data;
    });
};

export {
  getPlanFeatures,
  createPlanFeatures,
  viewPlanFeatures,
  updatePlanFeatures,
  deletePlanFeaturesById,
  checkDuplicatePlanFeatures
 
}
